import {
    REQUEST_CONFIGURATION,
    RECEIVE_CONFIGURATION,
    IConfigurationState,
    ConfigurationTypes,
    RECEIVE_CONFIGURATION_LOADER,
    GET_COUNTRY_LIST,
    SET_REDIRECT_TO_DASHBOARD,
    SET_CHILD_ACCOUNT_SWITCH_REDIRECT_URL,
    REDIRECT_TOKEN_URL,
    SET_LANGUAGE_OPTIONS,
    SET_ROUTE_LOADING,
    SET_CID_UNPAID_CHANNEL_DATA,
    RECEIVE_CONFIGURATION_DATA_LOADER,
    SET_SALES_TAX_DATA,
} from "./types";

const initialState: IConfigurationState = {
    configuration: {
        recaptchaSiteKey: "",
        idfLoginURL: "",
        partnerConfig: {},
        countryList: [],
    },
    childAccountSwitchRedirectURL: "",
    redirectToDashboard: false,
    isPartnerConfigLoading: false,
    loading: false,
    cid: "",
    channel: "",
    isPartnerConfigDataLoading: false,
    salesTax: 0.00,
    annualTax: 0.00,
};

export function configurationReducer(state = initialState, action: ConfigurationTypes): IConfigurationState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_CONFIGURATION:
            return {
                ...state,
                configuration: state.configuration,
                countryList: state.countryList,
            };
        case SET_REDIRECT_TO_DASHBOARD:
            return {
                ...state,
                redirectToDashboard: action.redirectToDashboard,
            };
        case SET_CHILD_ACCOUNT_SWITCH_REDIRECT_URL:
            return {
                ...state,
                childAccountSwitchRedirectURL: action.childAccountSwitchRedirectURL,
            };
        case RECEIVE_CONFIGURATION:
            return {
                ...state,
                configuration: action.configuration,
            };
        case RECEIVE_CONFIGURATION_LOADER:
            return {
                ...state,
                isPartnerConfigLoading: action.isPartnerConfigLoading,
            };
        case GET_COUNTRY_LIST:
            return {
                ...state,
                countryList: action.countryList,
            };
        case REDIRECT_TOKEN_URL:
            return {
                ...state,
                redirectToken: action.redirectToken,
            };
        case SET_LANGUAGE_OPTIONS:
            return {
                ...state,
                partnerLanguageOptions: action.partnerLanguageOptions,
            };
        case SET_ROUTE_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case SET_CID_UNPAID_CHANNEL_DATA:
            return {
                ...state,
                cid: action.cid,
                channel: action.channel,
            };
        case RECEIVE_CONFIGURATION_DATA_LOADER:
            return {
                ...state,
                isPartnerConfigDataLoading: action.isPartnerConfigDataLoading,
            };
        case SET_SALES_TAX_DATA:
            return {
                ...state,
                salesTax: action.salesTax,
                annualTax: action.annualTax,
            };
        default:
            return state;
    }
}
